import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { detectIE } from '../../../utilities/browserUtils';
import { emailTypeMap } from './emailTypeMap';
import { formatDateWithDashes } from '../../../utilities/dateFormatter';
// import { get } from 'lodash';
// import { isProposedEndDateRequired } from './utils';
import { isEstimatedEndDateMoveType } from './utils';
import { phoneTypeMap } from './phoneTypeMap';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import ConfirmModal from '../../../common/confirmModal.component';
import LogoSpinner from '../../../common/logoSpinner.component';
import NavigationPrompt from 'react-router-navigation-prompt';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SpinnerButton from '../../../common/spinnerButton.component';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import DuplicateAuthsModal from '../duplicateAuths/duplicateAuthsModal.component';
import AuthorizationModal from '../duplicateAuths/authorizationModal.component';

import {
  // GET_BUS_CODES_SUCCESS,
  getAuthorizationCustomFields,
  getBusCodes,
  getClientFieldListValues,
  getClientSpecificFields,
  getCountries,
  getPendingAuthorization,
  getReloPolicies,
  getStates,
  insertAuthorization,
  regenerateAuthPdf,
  submitAuthorization,
  submitAuthorizationForApproval,
  getDuplicateAuths,
  getTempFileDuplicateAuths,
  getTempAuthFiles,
  updateAuthorization,
  getTempPendingAuthById,
  getTempPendingAuthClientCustomFields,
  getClientInformation,
  getAllEnumerations,
  getAllCountries,
  getAllProvinces,
  updateTempPendingAuth,
  insertTempPendingAuth,
  deleteTempPendingAuthPTCodeHistory
} from '../authorizations.actions';

import { getPolicies } from 'modules/policies/policy.actions';

import {
  TOAST_MESSAGE_SEVERITY_ERROR, 
  TOAST_MESSAGE_SEVERITY_SUCCESS, 
  setBackButtonPath,
  setNumPendingTransferees,
  setPageTitle,
  showToast,
} from '../../layout/layout.actions';

import {
  removeRecentItem,
  trackRecentItem,
} from '../../../utilities/trackRecents';
import {
  requiredField,
  validDate,
  validEmail,
  validPhoneNumber
} from '../../../utilities/fieldValidation';

import EmployeeForm from './employeeForm.component';
import NotesForm from './notesForm.component';
import SummaryForm from './summaryForm.component';

import {
  getSelectedClientInformation,
  getUserPermissionsList,
  userHasPermission,
  isAirBornClient,
  isKlaTaxClient, //Added via AB#869
  // isBattelleEnergyAllianceClient, //Added via AB#869
  isSamsungClient,
  getUserName,
  isClientSelected, //Added via AB#1361
} from '../../../utilities/authUtils';

import TransfereeModal from '../duplicateAuths/transfereeModal.component';

import { setBaseMoveInfo } from 'modules/transferees/transferees.actions';

import { getAutoShipmentCost, getEstimates, getFlightPrice, getHomesalePriceByRegion, getPackLoadMovePrice, getTempLivingPriceByRegion } from 'modules/estimator/estimator.actions';
import { submitTempFile } from 'modules/authentication/authentication.actions';

// const DIVISION_BUS_CODE_LIST = 'BC1';

const TabContainer = (props) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    // marginTop: theme.spacing.unit * 3,
    backgroundColor: theme.palette.background.paper,
    marginBottom: '2rem',
  },
  saveButton: {
    marginRight: '0.5rem',
  },
  navButtons: {
    height: '100%',
    marginLeft: 'auto',
  },
  paperSection: {
    width: '100%',
    padding: '1rem',
    marginBottom: '0.75rem',
  },
  submittedText: {
    color: 'green',
    fontSize: '1.25rem',
    display: 'inline',
    marginLeft: '0.25rem',
    verticalAlign: 'middle',
  },
  submittedIcon: {
    color: 'green',
    fontSize: '1.25rem',
    verticalAlign: 'middle',
  },
  cannotBeEdited: {
    width: '100%', 
    backgroundColor: 'yellow', 
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 'medium',
    padding: '10px',
  },
});
//Holds any errors returned by the API when auth is inserted/updated/submitted
let apiFormErrors = [];

class AuthorizationEditCreate extends Component {
  constructor(props) {
    super(props);
    const bm = props.baseMoveInfo || {};
    
    const asText = (v) => (v === null || v === undefined ? '' : String(v));
    const asInt = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };
    const asGuidOrEmpty = (v) =>
      typeof v === 'string' && v.length > 0 ? v : '';
    
    this.state = {
      authorizationID: -1,
      tabIndex: 0,
      dirty: false,
      isEdit: false,
      isNewMove: props.baseMoveInfo !== null && props.baseMoveInfo !== undefined ? true : false,
      selectedAuth: {
        customFields: [],
        tempPTCodeHistories: [],
        tempFile: {
          tempFileId: 0,
          clientRecordId: asInt(bm.clientRecordId),
          divisionId: props.clientInfo?.clientDetails?.hasMultipleDivisions === false
            ? props.clientInfo?.clientDivisions?.[0]?.clientDivisionId ?? 0
            : 0,
          tempFileStatusId: '1777f26f-7158-4faf-94c1-399362f76bea',

          firstName: asText(bm.firstName),
          middleName: '',
          lastName: asText(bm.lastName),
          spouseFirstName: asText(bm.spouseFirstName),
          spouseLastName: asText(bm.spouseLastName),
          nickName: asText(bm.nickName),

          departureAddressLine1: asText(bm.departureAddressLine1),
          departureAddressLine2: asText(bm.departureAddressLine2),
          departureProvinceId: asGuidOrEmpty(bm.departureStateId),
          departureCity: asText(bm.departureCity),
          departureZipcode: asText(bm.departureZip),
          departureCountryId: asGuidOrEmpty(bm.departureCountryId),

          homePhone: asText(bm.oldHomePhone),
          workPhone: asText(bm.oldOfficePhone),
          mobilePhone: asText(bm.primaryPhoneNumber),
          workEmail: asText(bm.primaryEmailAddress),
          spouseEmail: asText(bm.spouseEmail),
          personalEmail: asText(bm.altEmail),

          destinationAddressLine1: asText(bm.destinationAddressLine1),
          destinationAddressLine2: asText(bm.destinationAddressLine2),
          destinationProvinceId: asGuidOrEmpty(bm.destinationStateId),
          destinationCity: asText(bm.destinationCity),
          destinationZipcode: asText(bm.destinationZip),
          destinationCountryId: asGuidOrEmpty(bm.destinationCountryId),

          isConfidentialFile: bm.isConfidentialFile === 'true' || bm.isConfidentialFile === true ? true : false,
          isVIP: bm.isVIP === 'true' || bm.isVIP === true ? true : false,
          effectiveDate: null,
          estimatedEndDate: null,

          employeeTypeId: '00000000-0000-0000-0000-000000000000',
          policyId: 0,
          moveTypeId: '00000000-0000-0000-0000-000000000000',

          notes: bm.AuthId
            ? `This authorization was generated as a new move for the transferee ${asText(
                bm.firstName
              )} ${asText(bm.lastName)} with ID ${asText(bm.fileNumber)}.`
            : bm.EstimateId
            ? `Created from cost estimate id: ${asText(bm.EstimateId)}`
            : '',

          addedOn: new Date(),
          modifiedOn: new Date(),
        }
      },
      isLoadingAuth: false,
      authSubmitted: false,
      isRegeneratingPdf: false,
      notesData: {
        notes: '',
      },
      isSubmitting: false,
      forceComponentRerender: Date.now(),
      duplicateAuths:{
        auths: [],
        lastName: '',
        helperText: undefined,
        selectedAuthorizationID: undefined,
        selectedMtID: undefined,
        displayAuthsTable: false,
        selectedLinkedAuthorizationID: undefined,
        isAuthSelect: !!props.baseMoveInfo?.fileId,
        linkedMtId: props.baseMoveInfo?.fileId ? parseInt(props.baseMoveInfo.fileId, 10) : undefined,
        linkedTempId: undefined,
        nextFileNumber: undefined
      },
      allValeroWorkLocationCities: [],
      allValeroWorkLocationCodes: [],
      hasConfidentialFileAccess: false
    };


    this.handleFormFieldChange = this.handleFormFieldChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleCustomFieldChange = this.handleCustomFieldChange.bind(this);
    // this.handleClientCustomFieldChange = this.handleClientCustomFieldChange.bind(
    //   this,
    // );
    this.handleContactChange = this.handleContactChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);
    this.handleFormSave = this.handleFormSave.bind(this);
    this.getFormErrors = this.getFormErrors.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleSubmitForApproval = this.handleSubmitForApproval.bind(this);
    this.handleRegeneratePdf = this.handleRegeneratePdf.bind(this);
    this.handleSelectDuplicateAuthorization = this.handleSelectDuplicateAuthorization.bind(this);
    this.handleSelectLinkedAuthorization = this.handleSelectLinkedAuthorization.bind(this);
    // this.getDivisionBusCode = this.getDivisionBusCode.bind(this);
    // this.startDateMustBeBeforeEndDate = this.startDateMustBeBeforeEndDate.bind(
    //   this,
    // );
    // this.endDateMustBeAfterStartDate = this.endDateMustBeAfterStartDate.bind(
    //   this,
    // );
  }
  
  async componentDidMount() {
    this._isMounted = true;
    this.props.setPageTitle(getSelectedClientInformation().id === '238'? 'MPC Authorizations' : 'My Authorizations');
    this.props.setBackButtonPath('/authorizations');
    if (this._isMounted) {
      this.setState({ isLoadingAuth: true });
    }
    let clientId = getSelectedClientInformation() && getSelectedClientInformation().id ? parseInt(getSelectedClientInformation().id) : null;
    
    // this.props.getCountries();
    // this.props.getStates();

      await this.props.getClientInformation(clientId);
      await this.props.getAllEnumerations();
      await this.props.getAllCountries();
      await this.props.getAllProvinces();
    
    // await this.props.getAuthorizationCustomFields();
    // await this.props.getClientSpecificFields({ AuthorizationID: null });
    // await this.props.getClientFieldListValues();
    // this.props.getReloPolicies();
    // if (userHasPermission('selfService:policies', this.props.clientDivisions)) {
    //   this.props.getPolicies();
    // }

    const selectedAuthId = this.props.authorizationID ? this.props.authorizationID : this.props.match.params.id;

    if (this._isMounted) {
      this.setState({authorizationID: !isNaN(selectedAuthId) ? selectedAuthId : -1});    
    }
    if (selectedAuthId && selectedAuthId !== 'new') {
      await this.props.getTempPendingAuthClientCustomFields(selectedAuthId);

      let response = await this.props.getTempPendingAuthById(
        selectedAuthId,
      );

      // check if we actually got an authorization.  if not, redirect to transferees
      if (
        response.response &&
        response.type === 'GET_PENDING_AUTH_FILE_SUCCESS'
      ) {
        let name = '';
        let type = 'pendingAuthorization';
        let existingAuth = response.response;
        if (existingAuth) {
          // const authClientId = String(existingAuth.tempFile.clientRecordId);
          // if (authClientId !== getSelectedClientInformation().id) {
          //   this.props.showToast('That authorization belongs to a different client. Please select the correct client to view it.', { severity: TOAST_MESSAGE_SEVERITY_ERROR } );
          //   this.props.history.push('/authorizations');
          //   return;
          // }
          if (existingAuth.tempFile.tempFileId) {
            name = `Pending Authorization #${  existingAuth.tempFile.tempFileId}`;
          }

          // Handle both camelCase and PascalCase for firstName/lastName
          const firstName = existingAuth.tempFile.firstName ?? existingAuth.tempFile.FirstName;
          const lastName = existingAuth.tempFile.lastName ?? existingAuth.tempFile.LastName;
          if (firstName && lastName) {
            name = `${firstName} ${lastName}`;
          }

          if (this.props.userInformation) {
            let UserName = this.props.userInformation.UserName;
            trackRecentItem(this.props.location.pathname, name, type, UserName);
          }

          // default values
          existingAuth.tempFile.isConfidentialFile = existingAuth.tempFile.isConfidentialFile ? existingAuth.tempFile.isConfidentialFile : false;
          existingAuth.tempFile.isVIP = existingAuth.tempFile.isVIP ? existingAuth.tempFile.isVIP : false;
          existingAuth.tempFile.departureCountryId = existingAuth.tempFile.departureCountryId ? this.props.countryEnums.find((country) => country.id === existingAuth.tempFile.departureCountryId).id : this.props.countryEnums.find((country) => country.countryCode === 'USA').id;
          existingAuth.tempFile.destinationCountryId = existingAuth.tempFile.destinationCountryId ? this.props.countryEnums.find((country) => country.id === existingAuth.tempFile.destinationCountryId).id : this.props.countryEnums.find((country) => country.countryCode === 'USA').id;
          existingAuth.tempFile.spouseEmail = existingAuth.tempFile.spouseEmail
            ? existingAuth.tempFile.spouseEmail
            : '';
          existingAuth.tempFile.AltEmail = existingAuth.tempFile.AltEmail
            ? existingAuth.tempFile.AltEmail
            : '';

          existingAuth.tempFile.tempFileStatusId = existingAuth.tempFile.tempFileStatusId ? existingAuth.tempFile.tempFileStatusId : '1777f26f-7158-4faf-94c1-399362f76bea';

          // Normalize policy id casing from API payloads so downstream dependency checks
          // always read a stable key.
          existingAuth.tempFile.policyId = existingAuth.tempFile.policyId ?? existingAuth.tempFile.PolicyId ?? 0;

          // IE lacks support for date pickers, need to support multiple input methods
          // format date with dashes from input data
          if (!detectIE()) {
            existingAuth.tempFile.effectiveDate = existingAuth.tempFile.effectiveDate
              ? formatDateWithDashes(existingAuth.tempFile.effectiveDate)
              : '';
            existingAuth.tempFile.estimatedEndDate = existingAuth.tempFile.estimatedEndDate
              ? formatDateWithDashes(existingAuth.tempFile.estimatedEndDate)
              : '';
          }
          if (detectIE()) {
            if (
              moment(
                existingAuth.tempFile.effectiveDate,
                'YYYY-MM-DDTHH:mm:ss',
                true,
              ).isValid()
            ) {
              existingAuth.tempFile.effectiveDate = formatDateWithDashes(
                existingAuth.tempFile.effectiveDate,
              );
            }

            if (
              moment(
                existingAuth.tempFile.estimatedEndDate,
                'YYYY-MM-DDTHH:mm:ss',
                true,
              ).isValid()
            ) {
              existingAuth.tempFile.estimatedEndDate = formatDateWithDashes(
                existingAuth.tempFile.estimatedEndDate,
              );
            }
          }

          // Merge custom field definitions with existing values to ensure fieldListValues is available for dropdowns
          let mergedCustomFields = [];
          if (this.props.clientInfo && this.props.clientInfo.clientCustomFields && this.props.clientInfo.clientCustomFields.length > 0) {
            mergedCustomFields = this.props.clientInfo.clientCustomFields.map((field) => {
              const existingFieldValue = existingAuth.tempCustomFieldValues && existingAuth.tempCustomFieldValues.find((cf) => cf.customFieldCommonId === field.customFieldCommonId);
              return {
                tempCustomFieldValueId: existingFieldValue ? existingFieldValue.tempCustomFieldValueId : 0,
                tempFileId: existingAuth.tempFile.tempFileId,
                customFieldCommonId: field.customFieldCommonId,
                fieldId: field.fieldId,
                fieldLabel: field.fieldLabel,
                fieldTypeId: field.fieldTypeId,
                fieldStatusId: field.fieldStatusId,
                fieldListValues: field.fieldListValues,
                isRequiredField: field.isRequiredField,
                isFieldDependentOn: field.isFieldDependentOn,
                fieldDependedOnId: field.fieldDependedOnId ? field.fieldDependedOnId : null,
                fieldDependedOnValueId: field.fieldDependedOnValueId ? field.fieldDependedOnValueId : null,
                fieldValue: existingFieldValue ? existingFieldValue.fieldValue : '',
              }
            });
          } else {
            mergedCustomFields = existingAuth.tempCustomFieldValues ? existingAuth.tempCustomFieldValues : [];
          }

          if (this._isMounted) {
            this.setState({
              selectedAuth: {
                tempFile: existingAuth.tempFile,
                customFields: mergedCustomFields,
                tempPTCodeHistories: Array.isArray(existingAuth.tempPTCodeHistories)
                  ? existingAuth.tempPTCodeHistories.map((ptCode) => this.normalizePTCodeHistory(ptCode))
                  : [],
              },
              isEdit: true,
              allValeroWorkLocationCities: this?.props?.clientFields?.find(field => field.FieldName === "ValeroWorkLocationCity")?.FieldList || [],
              allValeroWorkLocationCodes: this?.props?.clientFields?.find(field => field.FieldName === "ValeroWorkLocationCode")?.FieldList || [],
            });
        
            //if this.props.readonly is set then that mean we're opening this from the authorizationModal and duplicateAuthsModal so we don't wanto to edit this
            // once submitted (any status other than Pending) the auth can no longer be edited by the client
            const isPending = (existingAuth.tempFile.tempFileStatusId || '').toLowerCase() === '1777f26f-7158-4faf-94c1-399362f76bea';
            if(this.props.readOnly || !isPending) this.setState({ authSubmitted: true });
          }
        }
      } else {
        // no auth returned
        this.props.showToast(response.messages, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        // this.props.history.push('/authorizations');
      }
    }

    if(this.props.clientInfo && this.props.clientInfo.clientContacts && this.props.clientInfo.clientContacts.length > 0){
      let currentToken = getUserName();
      let currentUser = this.props.clientInfo.clientContacts.find((contact) => contact.contact.auth0UserId === currentToken);
      if(currentUser)
        this.setState({ hasConfidentialFileAccess: currentUser.contact.hasConfidentialFileAccess });
    }


    if (selectedAuthId === 'new') {
      // let customFields = await this.props.getTempPendingAuthClientCustomFields(this.props.match.params.id);
      let newAuth = this.state.selectedAuth;
      newAuth.tempFile.divisionId = this.props.clientInfo?.clientDetails?.hasMultipleDivisions === false
        ? this.props.clientInfo?.clientDivisions?.[0]?.clientDivisionId ?? 0
        : 0;
      // if(customFields.type === 'GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_SUCCESS') {
      //   newAuth.tempCustomFieldValues = customFields.response;
      // }

      if(this.props.clientInfo && this.props.clientInfo.clientCustomFields && this.props.clientInfo.clientCustomFields.length > 0) {
            newAuth.customFields = this.props.clientInfo.clientCustomFields.map((field) => {
              return {
                tempCustomFieldValueId: 0,
                tempFileId: this.state.selectedAuth.tempFile.tempFileId,
                customFieldCommonId: field.customFieldCommonId,
                fieldId: field.fieldId,
                fieldLabel: field.fieldLabel,
                fieldTypeId: field.fieldTypeId,
                fieldStatusId: field.fieldStatusId,
                fieldListValues: field.fieldListValues,
                isRequiredField: field.isRequiredField,
                isFieldDependentOn: field.isFieldDependentOn,
                fieldDependedOnId: field.fieldDependedOnId ? field.fieldDependedOnId : null,
                fieldDependedOnValueId: field.fieldDependedOnValueId ? field.fieldDependedOnValueId : null,
                fieldValue: '',
              }
            });
          
          }

      newAuth.tempPTCodeHistories = Array.isArray(newAuth.tempPTCodeHistories)
        ? newAuth.tempPTCodeHistories.map((ptCode) => this.normalizePTCodeHistory(ptCode))
        : [];
      // await this.props.getClientSpecificFields({ AuthorizationID: null });

      // default values
      if (this.props.countryEnums && this.props.countryEnums.length > 0) {
        newAuth.tempFile.departureCountryId = newAuth.tempFile.departureCountryId ||  this.props.countryEnums.find((country) => country.countryCode === 'USA')?.id;
        newAuth.tempFile.destinationCountryId = newAuth.tempFile.destinationCountryId || this.props.countryEnums.find((country) => country.countryCode === 'USA')?.id;
      }
      if (this._isMounted) {
        await this.setState({
          isEdit: false,
          selectedAuth: {
            ...newAuth
          },
          allValeroWorkLocationCities: this?.props?.clientFields?.find(field => field.FieldLabel === "ValeroWorkLocationCity")?.FieldListValues || [],
          allValeroWorkLocationCodes: this?.props?.clientFields?.find(field => field.FieldLabel === "ValeroWorkLocationCode")?.FieldListValues || [],
        });
    }
    }

    // const response = await this.props.getBusCodes();
    // if (response.type === GET_BUS_CODES_SUCCESS){
    //   const moveTypes = response.response ? response.response.filter((item) => item.BusCodeType === 'MOVETYPE') : [];
    //   const defaultMoveType = moveTypes.find((mt) => String(mt.User9) === '1');
    //   if (!this.state.selectedAuth.MoveType && defaultMoveType){
    //     await this.setState({
    //       selectedAuth: {
    //         ...this.state.selectedAuth,
    //         MoveType: defaultMoveType.BusCode,
    //       },
    //     });
    //   }
    // }

    if (this._isMounted) {
      this.setState({ isLoadingAuth: false });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  normalizePTCodeHistory = (ptCode = {}) => {
    const formatPTCodeDate = (value) => {
      if (value === null || value === undefined || value === '') return '';
      const dateString = `${value}`;
      return dateString.includes('T') ? dateString.split('T')[0] : dateString;
    };

    return {
      ...ptCode,
      tempPTCodeHistoryId: ptCode.tempPTCodeHistoryId ?? ptCode.TempPTCodeHistoryId ?? 0,
      tempFileId: ptCode.tempFileId ?? ptCode.TempFileId ?? 0,
      clientRecordId: ptCode.clientRecordId ?? ptCode.ClientRecordId ?? this.state?.selectedAuth?.tempFile?.clientRecordId ?? 0,
      isNonStandard: ptCode.isNonStandard ?? ptCode.IsNonStandard ?? false,
      projectCode: ptCode.projectCode ?? ptCode.ProjectCode ?? '',
      taskCode: ptCode.taskCode ?? ptCode.TaskCode ?? '',
      percentage: ptCode.percentage ?? ptCode.Percentage ?? '',
      effectiveStartDate: formatPTCodeDate(ptCode.effectiveStartDate ?? ptCode.EffectiveStartDate ?? ''),
      effectiveEndDate: formatPTCodeDate(ptCode.effectiveEndDate ?? ptCode.EffectiveEndDate ?? ''),
      notes: ptCode.notes ?? ptCode.Notes ?? '',
    };
  };

  isPTCodeHistoryEmpty = (ptCode = {}) => {
    const projectCode = ptCode.projectCode ? `${ptCode.projectCode}`.trim() : '';
    const taskCode = ptCode.taskCode ? `${ptCode.taskCode}`.trim() : '';
    const percentage = ptCode.percentage !== null && ptCode.percentage !== undefined ? `${ptCode.percentage}`.trim() : '';
    const effectiveStartDate = ptCode.effectiveStartDate ? `${ptCode.effectiveStartDate}`.trim() : '';
    const effectiveEndDate = ptCode.effectiveEndDate ? `${ptCode.effectiveEndDate}`.trim() : '';
    const notes = ptCode.notes ? `${ptCode.notes}`.trim() : '';

    return !projectCode && !taskCode && !percentage && !effectiveStartDate && !effectiveEndDate && !notes;
  };

  handleTabChange = (event, value) => {
    if (this._isMounted) {
      this.setState({ tabIndex: value });
    }
  };

  async nextPage() {
    let { tabIndex } = this.state;
    if (tabIndex >= 2) {
      return;
    }

    const saved = await this.handleFormSave(false);

    if (saved && this._isMounted) {
      this.setState({ tabIndex: tabIndex + 1 });
    }
  }

  prevPage() {
    if (this._isMounted) {
      let { tabIndex } = this.state;
      if (tabIndex > 0) {
        this.setState({ tabIndex: tabIndex - 1 });
      }
   }
  }

  // getDivisionBusCode() {
  //   if (this.state.selectedAuth) {
  //     const { CustomFields } = this.state.selectedAuth;
  //     if (CustomFields && CustomFields.length > 0) {
  //       let divCodes =
  //         !!this.props.busCodes &&
  //         this.props.busCodes.filter(
  //           (code) => code.BusCodeType === DIVISION_BUS_CODE_LIST,
  //         );
  //       return !!divCodes && divCodes.length > 0
  //         ? CustomFields.find((cf) => cf.BusCodeList === DIVISION_BUS_CODE_LIST)
  //         : null;
  //     }
  //     return null;
  //   }
  // }

  getUserField(fieldName) {
    if (this.state.selectedAuth) {
      const { tempCustomFieldValues } = this.state.selectedAuth;
      if (tempCustomFieldValues && tempCustomFieldValues.length > 0) {
        const field = tempCustomFieldValues.find(
          (cf) => cf.FieldLabel === fieldName,
        );
        return field ? field.FieldValue : null;
      }
      return null;
    }
  }

  // silent suppresses the success toast (used when saving as part of submit); errors are still shown
  async handleFormSave(exit, silent = false) {
    // guard against Next/Save and Exit firing concurrently and double-inserting
    if (this.state.isSubmitting) {
      return false;
    }
    this.setState({ isSubmitting: true });

    // Create a deep copy for the API call to avoid mutating state
    let formData = JSON.parse(JSON.stringify(this.state.selectedAuth));

    // add client id to save data
    if (this.props.clientInfo && this.props.clientInfo.clientDetails.clientRecordId) {
      formData.tempFile.clientRecordId = this.props.clientInfo.clientDetails.clientRecordId;
    }

    // automatically add division code
    if (this.props.clientInfo && this.props.clientInfo.clientDetails?.hasMultipleDivisions) {
      formData.tempFile.divisionId = formData.tempFile.divisionId ? formData.tempFile.divisionId : 0;
    }
    // add division code for clients without multiple divisions (default division code)
    if (this.props.clientInfo?.clientDetails?.hasMultipleDivisions === false) {
      formData.tempFile.divisionId = this.props.clientInfo.clientDivisions?.[0]?.clientDivisionId ?? 0;
    }

    formData.tempFile.destinationProvinceId = formData.tempFile.destinationProvinceId === '' ? null : formData.tempFile.destinationProvinceId;
    formData.tempFile.departureProvinceId = formData.tempFile.departureProvinceId === '' ? null : formData.tempFile.departureProvinceId;
    formData.tempFile.effectiveDate = formData.tempFile.effectiveDate === '' ? null : formData.tempFile.effectiveDate;
    // the estimated end date only applies to the move types that show it
    formData.tempFile.estimatedEndDate = isEstimatedEndDateMoveType(formData.tempFile.moveTypeId) && formData.tempFile.estimatedEndDate
      ? formData.tempFile.estimatedEndDate
      : null;

    const { linkedTempId, linkedMtId, isAuthSelect } = this.state.duplicateAuths;

    formData.tempFile.isAuthorizationFileId = isAuthSelect ? true : false;  
    formData.tempFile.selectedSimilarAuthId = isAuthSelect && linkedMtId ? linkedMtId : linkedTempId ? linkedTempId : null;

    if(formData.customFields && formData.customFields.length > 0) {
      formData.customFields = this.state.selectedAuth.customFields.map((field) => {
        return {
          tempFileCustomFieldId: field.tempFileCustomFieldId ? field.tempFileCustomFieldId : 0,
          tempFileId: field.tempFileId ? field.tempFileId : 0,
          customFieldCommonId: field.customFieldCommonId,
          customFieldValue: field.fieldValue,
        }
      });
    }

    if (Array.isArray(formData.tempPTCodeHistories)) {
      const clientRecordId = formData?.tempFile?.clientRecordId || this?.props?.clientInfo?.clientDetails?.clientRecordId || 0;
      const tempFileId = formData?.tempFile?.tempFileId || 0;

      formData.tempPTCodeHistories = formData.tempPTCodeHistories
        .map((ptCode) => this.normalizePTCodeHistory(ptCode))
        .filter((ptCode) => !this.isPTCodeHistoryEmpty(ptCode))
        .map((ptCode) => {
          const parsedPercentage = ptCode.percentage === '' || ptCode.percentage === null || ptCode.percentage === undefined
            ? null
            : Number(ptCode.percentage);

          return {
            tempPTCodeHistoryId: Number(ptCode.tempPTCodeHistoryId) || 0,
            tempFileId: Number(ptCode.tempFileId) || tempFileId,
            clientRecordId: Number(ptCode.clientRecordId) || clientRecordId,
            isNonStandard: !!ptCode.isNonStandard,
            projectCode: ptCode.projectCode ? `${ptCode.projectCode}`.trim() : '',
            taskCode: ptCode.taskCode ? `${ptCode.taskCode}`.trim() : '',
            percentage: Number.isNaN(parsedPercentage) ? null : parsedPercentage,
            effectiveStartDate: ptCode.effectiveStartDate || null,
            effectiveEndDate: ptCode.effectiveEndDate || null,
            notes: ptCode.notes ? `${ptCode.notes}` : '',
          };
        });
    }

    // update
    if (this.state.selectedAuth.tempFile.tempFileId !== 0) {
      let response = await this.props.updateTempPendingAuth(formData);
      if (response.type === 'PUT_TEMP_FILE_SUCCESS') {
        if (!silent) {
          this.props.showToast('Successfully saved authorization.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        }
        this.setState({ dirty: false });

        if (this.props.baseMoveInfo) {
          this.props.setBaseMoveInfo(null);
        }

        if (exit) {
          this.props.history.push('/authorizations');
        }

        this.setState({ isSubmitting: false });
        return true;
      }
      else if(response.hasErrors) {
        this.props.showToast(
          response.messages, { severity: TOAST_MESSAGE_SEVERITY_ERROR },
        );
      }
      else {
        this.props.showToast(
          'Error saving authorization. Please check your connection and try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR },
        );
      }

      this.setState({ isSubmitting: false });
      return false;
    } else {
      // new - TODO: RESOLVE POLICYID FK CONSTRAINT ERROR
      let response = await this.props.insertTempPendingAuth(formData);
      // update count
      // await this.props.getPendingAuthorizations();

      if (response.type === 'POST_TEMP_FILE_SUCCESS') {
        const createdTempFileId =
          Number(response?.response?.tempFile?.tempFileId) ||
          Number(response?.response?.tempFileId) ||
          Number(formData?.tempFile?.tempFileId) ||
          0;

        let resolvedTempFileId = createdTempFileId;

        // the POST response didn't include a usable tempFileId - look the record up by its
        // identifying fields so we can stamp the real id into state. Without this, tempFileId
        // stays 0 and the next save (e.g. Save and Exit) inserts a duplicate authorization
        // instead of updating the one that was just created.
        if (resolvedTempFileId <= 0) {
          const selectedClient = getSelectedClientInformation();
          const selectedClientId = selectedClient && selectedClient.id ? parseInt(selectedClient.id, 10) : null;

          if (!Number.isNaN(selectedClientId) && selectedClientId !== null) {
            const tempFilesResponse = await this.props.getTempAuthFiles(selectedClientId);
            if (tempFilesResponse.type === 'GET_TEMP_AUTH_FILES_SUCCESS' && Array.isArray(tempFilesResponse.response)) {
              const normalizeValue = (value) => `${value || ''}`.trim().toLowerCase();
              const createdTempFile = formData.tempFile || {};

              const matchedTempFiles = tempFilesResponse.response.filter((item) => {
                const tempFile = item && item.tempFile ? item.tempFile : item;
                const firstName = tempFile.firstName ?? tempFile.FirstName;
                const lastName = tempFile.lastName ?? tempFile.LastName;
                const workEmail = tempFile.workEmail ?? tempFile.WorkEmail;

                return (
                  normalizeValue(firstName) === normalizeValue(createdTempFile.firstName) &&
                  normalizeValue(lastName) === normalizeValue(createdTempFile.lastName) &&
                  normalizeValue(workEmail) === normalizeValue(createdTempFile.workEmail)
                );
              });

              if (matchedTempFiles.length > 0) {
                resolvedTempFileId = matchedTempFiles.reduce((maxId, item) => {
                  const tempFile = item && item.tempFile ? item.tempFile : item;
                  const tempFileId = Number(tempFile.tempFileId ?? tempFile.TempFileId ?? 0);
                  return tempFileId > maxId ? tempFileId : maxId;
                }, 0);
              }
            }
          }
        }

        if (resolvedTempFileId > 0 && Array.isArray(formData.tempPTCodeHistories) && formData.tempPTCodeHistories.length > 0) {
          const postCreateUpdatePayload = {
            ...formData,
            tempFile: {
              ...formData.tempFile,
              tempFileId: resolvedTempFileId,
            },
            customFields: Array.isArray(formData.customFields)
              ? formData.customFields.map((field) => ({
                ...field,
                tempFileId: resolvedTempFileId,
              }))
              : [],
            tempPTCodeHistories: formData.tempPTCodeHistories.map((ptCode) => ({
              ...ptCode,
              tempPTCodeHistoryId: Number(ptCode.tempPTCodeHistoryId) || 0,
              tempFileId: resolvedTempFileId,
            })),
          };

          const ptCodeUpdateResponse = await this.props.updateTempPendingAuth(postCreateUpdatePayload);

          if (ptCodeUpdateResponse.type !== 'PUT_TEMP_FILE_SUCCESS') {
            this.props.showToast(
              'Authorization was created, but PT code rows failed to save during the post-create update.',
              { severity: TOAST_MESSAGE_SEVERITY_ERROR },
            );
          }
        } else if (Array.isArray(formData.tempPTCodeHistories) && formData.tempPTCodeHistories.length > 0 && resolvedTempFileId <= 0) {
          this.props.showToast(
            'Authorization was created, but PT code rows could not be saved because the new temp file id was not returned.',
            { severity: TOAST_MESSAGE_SEVERITY_ERROR },
          );
        }

        this.setState({ dirty: false });
        if (!silent) {
          this.props.showToast('Successfully created authorization.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        }
        this.props.setNumPendingTransferees(
          this.props.pendingAuthorizations.length,
        );

        // stamp the new tempFileId into state immediately (regardless of exit) so that
        // a subsequent save - even one that races ahead of history navigation - is
        // treated as an update instead of inserting a duplicate authorization
        if (resolvedTempFileId > 0) {
          this.setState({
            selectedAuth: {
              ...this.state.selectedAuth,
              tempFile: {
                ...this.state.selectedAuth.tempFile,
                tempFileId: resolvedTempFileId,
              },
            },
          });
        }

        if (exit) {
          this.props.history.push('/authorizations');
        } else if (resolvedTempFileId > 0) {
          // stay on the form, but switch the route/state over to the newly created record
          //const nextTabIndex = this.state.tabIndex + 1;
          this.props.history.push(`/authorizations/${resolvedTempFileId}`);
          const refetchResponse = await this.props.getTempPendingAuthById(resolvedTempFileId);
          // only replace selectedAuth if the refetch actually succeeded - otherwise keep the
          // tempFileId we already stamped above instead of clobbering it with stale/racy props.
          // Advance tabIndex here, together with the refreshed data, so the user lands on the
          // next tab only once the refresh has completed.
          if (refetchResponse && refetchResponse.type === 'GET_PENDING_AUTH_FILE_SUCCESS' && refetchResponse.response) {
            this.setState({
              authorizationID: resolvedTempFileId,
              selectedAuth: refetchResponse.response,
            });
          } else {
            this.setState({ authorizationID: resolvedTempFileId });
          }
        }

        this.setState({ isSubmitting: false });
        return true;
      }
      else if(response.hasErrors) {
        this.props.showToast(
          `${response.messages}`, { severity: TOAST_MESSAGE_SEVERITY_ERROR },
        );
      } 
      else {
        this.props.showToast(
          'Error creating authorization. Please check your connection and try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR },
        );
      }

      this.setState({ isSubmitting: false });
      return false;
    }
  }

  async handleFormSubmit() {
    // persist unsaved edits first (e.g. notes typed before clicking straight over to the Summary tab)
    if (this.state.dirty) {
      const saved = await this.handleFormSave(false, true);
      if (!saved) {
        return;
      }
    }

    this.setState({ isSubmitting: true });

    let response = await this.props.submitTempFile(this.state.selectedAuth.tempFile.tempFileId);
    if (response.type === 'SUBMIT_TEMP_FILE_SUCCESS') {
      this.props.showToast('Successfully submitted authorization.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });

      if (this.props.userInformation) {
        let UserName = this.props.userInformation.UserName;
        removeRecentItem(
          this.props.location.pathname,
          'pendingAuthorization',
          UserName,
        );
      }

      this.setState({ dirty: false, isSubmitting: false });
      this.props.history.push('/authorizations');
    } else {
      this.setState({ isSubmitting: false });
      this.props.showToast(
        'Error submitting authorization. Please check your connection and try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR },
      );
    }

    // TODO: Add back cost estimate logic when submitting temp file
    // check for a cost estimate
    // if (auth.Comment && auth.Comment.length > 0) {
    //   const estimateIdRegex = auth.Comment.match(/cost estimate id: (\d+)/i);
    //   if (estimateIdRegex && estimateIdRegex[1]) {
    //     const estimateId = parseInt(estimateIdRegex[1]);
    //     let estimateResponse = await this.props.getEstimates();
    //     if (estimateResponse.type === 'GET_ESTIMATES_SUCCESS') {
    //       const estimate = estimateResponse.response.find(
    //         (e) => e.estimateId === estimateId,
    //       );

    //       if (estimate) {
    //         const perDiemSelectionId = estimate?.savedBenefits ? estimate.savedBenefits.find((sb) => sb.benefitNumber === 3)?.options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
    //         const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;

    //         let homefindingDays = numDaysBetweenFlights;
    //         let avgHomesalePrice = null;
    //         let perDiemRate = null;
    //         let avgHomesalePriceOrigin = null;
    //         let flightCost = null;
    //         let distance = null;

    //         let autoShipmentCost = null;
    //         let packLoadCost = null;
    //         let thirtyDayStorageCost = null;
    //         let sixtyDayStorageCost = null;
    //         let tempLivingDaysCost = null;

    //         if (estimate.destination && estimate.destination.city && estimate.destination.state) {
    //             const gsaResp = await getGsaPerDiem(estimate.destination.city, estimate.destination.state, '2025');
    //             const gsaDestinationCity = gsaResp.rates[0].rate[0].city;
    //             const gsaDestinationState = gsaResp.rates[0].state;

    //             let regionName = 'United States';
    //             if (gsaDestinationCity !== null && gsaDestinationState !== null) {
    //               regionName = `${gsaDestinationCity}, ${gsaDestinationState}`;
    //             }

    //             const homesalePriceResp = await this.props.getHomesalePriceByRegion(regionName);
    //             if (homesalePriceResp.response) {
    //               avgHomesalePrice = parseFloat(homesalePriceResp.response.averagePrice.replace(/[$,]+/g,""));
    //             }

    //             let currentDate = new Date();
    //             let fullRate = gsaResp.rates[0].rate[0].months.month.find((rt) => rt.number === (currentDate.getMonth() + 1));
    //             perDiemRate = fullRate.value * 1.2;

    //             if (estimate.origin && estimate.origin.city && estimate.origin.state) {
    //               let newDistance = await getDistance(estimate.origin, estimate.destination);
    //               distance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;

    //               if (distance > 0) {
    //                 const autoShipmentResp = await this.props.getAutoShipmentCost(distance);
    //                 if (autoShipmentResp.response && autoShipmentResp.response.price) {
    //                     autoShipmentCost = parseFloat(autoShipmentResp.response.price);
    //                 }
    //               }

    //               if (distance > 0 && estimate.topLevelInputOneId !== null && estimate.topLevelInputTwoId !== null) {
    //                 const homeType = (estimate.topLevelInputOneId === 1 || estimate.topLevelInputOneId === 2) ? 2 : 1;
                    
    //                 const packLoadMoveResp = await this.props.getPackLoadMovePrice( distance, homeType, estimate.topLevelInputTwoId );
    //                 if (packLoadMoveResp.response) {
    //                   packLoadCost = parseFloat(packLoadMoveResp.response.price.replace('$', '').replace(',', ''));
    //                   thirtyDayStorageCost = parseFloat(packLoadMoveResp.response.thirtyDayStorage.replace('$', '').replace(',', ''));
    //                   sixtyDayStorageCost = parseFloat(packLoadMoveResp.response.sixtyDayStorage.replace('$', '').replace(',', ''));
    //                 } else {
    //                   packLoadCost = 0;
    //                   thirtyDayStorageCost = 0;
    //                   sixtyDayStorageCost = 0;
    //                 }
    //               }

    //               if (estimate.topLevelInputThreeId !== null) {
    //                 const tempLivingPriceResp = await this.props.getTempLivingPriceByRegion( estimate.destination.state, `${estimate.destination.city}, ${estimate.destination.state}`, estimate.topLevelInputThreeId );
    //                 tempLivingDaysCost = parseFloat(tempLivingPriceResp.response.median.replace('$', ''));
    //               }
                  

    //               const gsaOriginResp = await getGsaPerDiem(estimate.origin.city, estimate.origin.state, '2025');
    //               const gsaOriginCity = gsaOriginResp.rates[0].rate[0].city;
    //               const gsaOriginState = gsaOriginResp.rates[0].state;

    //               let originRegionName = 'United States';
    //               if (gsaOriginCity !== null && gsaOriginState !== null) {
    //                   originRegionName = `${gsaOriginCity}, ${gsaOriginState}`;
    //               }

    //               const homesalePriceOriginResp = await this.props.getHomesalePriceByRegion(originRegionName);
    //               if (homesalePriceOriginResp.response) {
    //                   avgHomesalePriceOrigin = parseFloat(homesalePriceOriginResp.response.averagePrice.replace(/[$,]+/g,""));
    //               }

    //               const perDiemSelectionId = estimate?.savedBenefits ? estimate.savedBenefits.find((sb) => sb.benefitNumber === 3)?.options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
    //               const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;

    //               let baseDate = new Date();
    //               baseDate.setDate(baseDate.getDate() + 14);
    //               const departureDate = baseDate.toISOString().split('T')[0];
    //               baseDate.setDate(baseDate.getDate() + numDaysBetweenFlights);
    //               const returnDate = baseDate.toISOString().split('T')[0];

    //               const flightCostResp = await this.props.getFlightPrice({
    //                   departureCity: gsaOriginCity ? gsaOriginCity : origin.city,
    //                   departureState: gsaOriginState,
    //                   destinationCity: gsaDestinationCity ? gsaDestinationCity : estimate.destination.city,
    //                   destinationState: gsaDestinationState,
    //                   departureDate: departureDate,
    //                   returnDate: returnDate,
    //                   mileage: distance,
    //               });

    //               if (flightCostResp.response && flightCostResp.response.price) {
    //                   flightCost = parseFloat(flightCostResp.response.price.total.replace(/[$,]+/g,""));
    //               }
    //             } 
    //         }

    //         const estimateInfo = {
    //           EstimateId: estimate.estimateId,
    //           TransfereeName: estimate.transfereeName,
    //           ReloPolicy: estimate.reloPolicy,
    //           OriginCity: estimate.origin.city,
    //           OriginState: estimate.origin.state,
    //           DestinationCity: estimate.destination.city,
    //           DestinationState: estimate.destination.state,
    //           Distance: distance,
    //           AccompanyingAdults: estimate.accompanyingAdults,
    //           PerDiemRate: perDiemRate,
    //           AvgHomesalePrice: avgHomesalePrice,
    //           AvgHomesalePriceOrigin: avgHomesalePriceOrigin,
    //           FlightCost: flightCost,
    //           HomefindingDays: homefindingDays,
    //           ApplyTaxGrossUp: estimate.applyTaxGrossUp,
    //           AutoShipmentCost: autoShipmentCost,
    //           TopLevelInputOneId: estimate.topLevelInputOneId,
    //           TopLevelInputTwoId: estimate.topLevelInputTwoId,
    //           TopLevelInputThreeId: estimate.topLevelInputThreeId,
    //           TopLevelInputFourId: estimate.topLevelInputFourId,
    //           TopLevelInputFive: estimate.topLevelInputFive,
    //           TopLevelInputSix: estimate.topLevelInputSix,
    //           TopLevelInputSeven: estimate.topLevelInputSeven,
    //           PackLoadCost: packLoadCost,
    //           ThirtyDayStorageCost: thirtyDayStorageCost,
    //           SixtyDayStorageCost: sixtyDayStorageCost,
    //           TempLivingDaysCost: tempLivingDaysCost,
    //           SavedBenefits: estimate.savedBenefits, 
    //         }

    //         auth.EstimateSummary = estimateInfo;
    //       }
    //     }
    //   }
    // }
  }

  async handleSubmitForApproval() {
    this.setState({ isSubmitting: true });
    let auth = Object.assign({}, this.state.selectedAuth);

    // add client id to save data
    let clientInfo = getSelectedClientInformation();
    if (clientInfo && clientInfo.id) {
      auth.ClientId = clientInfo.id;
    }

    let response = await this.props.submitAuthorizationForApproval(auth);

    if (response.type === 'SUBMIT_AUTH_FOR_APPROVAL_SUCCESS') {
      this.props.showToast(
        'Successfully submitted authorization for approval', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS },
      );

      this.setState({ dirty: false, isSubmitting: false });
      this.props.history.push('/authorizations');
    } else {
      this.setState({ isSubmitting: false });
      this.props.showToast(
        'Error submitting authorization for approval. Please check your connection and try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR },
      );
    }
  }

  async handleRegeneratePdf() {
    const authorizationFileId = this.state.selectedAuth.AuthorizationID;

    this.setState({ isRegeneratingPdf: true });

    try {
      await this.props.regenerateAuthPdf(authorizationFileId);
      this.props.showToast(
        `The Auth PDF has been regenerated successfully for authorization ${authorizationFileId}. You should receive an email with the attached PDF.`,
        TOAST_MESSAGE_SEVERITY_SUCCESS
      );
    } catch (error) {
      this.props.showToast(
        `There was an error regenerating the Auth PDF for authorization ${authorizationFileId}. Please try again later.`,
        TOAST_MESSAGE_SEVERITY_ERROR
      );
    } finally {
      this.setState({ isRegeneratingPdf: false });
    }
  }
  
  handleDuplicateAuthsModalClose = (event) => {
    this.setState({duplicateAuths: {...this.state.duplicateAuths, displayAuthsTable: false }});
  };

  handleDisplayAuthsModalClose = (event) => {
    this.setState({duplicateAuths: {...this.state.duplicateAuths, selectedAuthorizationID: undefined, selectedMtID: undefined}});
  };

  handleSetSelectedAuthorization = (authorizationID) => {    
    this.setState({duplicateAuths: {...this.state.duplicateAuths, selectedAuthorizationID: authorizationID}});
  }

  handleSelectDuplicateAuthorization = (tempId, authFileId, nextFileNumber) => {
    let currentLinkedTempId = this.state.duplicateAuths.linkedTempId;
    let currentLinkedMtId = this.state.duplicateAuths.linkedMtId;
    let currentNextFileNumber = this.state.duplicateAuths.nextFileNumber;
    this.setState(prev => ({
      duplicateAuths: {
        ...prev.duplicateAuths,

        isAuthSelect: authFileId === undefined || authFileId === null || authFileId === 0 ? false : true,
        linkedMtId: currentLinkedMtId === authFileId ? undefined : authFileId,
        linkedTempId: currentLinkedTempId === tempId ? undefined : tempId,
        nextFileNumber: currentNextFileNumber === nextFileNumber ? undefined : nextFileNumber
      }
    }));
  };

  handleClearDuplicateAuthorization = () => {
    this.setState(prev => ({
      duplicateAuths: {
        ...prev.duplicateAuths,
        selectedAuthorizationID: undefined
      }
    }));
  };

  handleReopenDuplicateModal = () => {
    this.setState(prev => ({
      duplicateAuths: {
        ...prev.duplicateAuths,
        displayAuthsTable: true
      }
    }));
  };

  handleSetSelectedTransferee = (mtAuthId) => {
    this.setState({duplicateAuths: {...this.state.duplicateAuths, selectedMtID: mtAuthId}});
  }

  handleSelectLinkedAuthorization = (authorizationID) => {
    let currentSelectedAuthId = this.state.duplicateAuths.selectedLinkedAuthorizationID;
    this.setState(prev => ({
      duplicateAuths: {
        ...prev.duplicateAuths,
        selectedLinkedAuthorizationID: currentSelectedAuthId === authorizationID ? undefined : authorizationID
      }
    }));
  };

  handleOnBlur = (name) => async (event) => {
    if (name === 'lastName'){
      //If MPC, return
      if(getSelectedClientInformation().id === '238') return;
      //make sure the value has actually changed before calling the API
      if(this.state.duplicateAuths.lastName === this.state.selectedAuth.tempFile.lastName) return;

      //check to see if there is input
      if(this.state.selectedAuth.tempFile.lastName.length === 0){
        this.setState({duplicateAuths: {...this.state.duplicateAuths, auths: [], lastName: this.state.selectedAuth.tempFile.lastName, helperText: undefined}});   
        return;
      }

      this.setState({duplicateAuths: {...this.state.duplicateAuths, auths: [], lastName: this.state.selectedAuth.tempFile.lastName, helperText: 'Checking for similar auths...'}});

      let tempLast = this.state.selectedAuth.tempFile.lastName;
      let tempId = this.state.selectedAuth.tempFile.tempFileId ? this.state.selectedAuth.tempFile.tempFileId : 0;
      let tempClientId = this.props.clientInfo.clientDetails.clientRecordId;
      
      //call API 
      let response = await this.props.getTempFileDuplicateAuths({ clientId: tempClientId, lastName: tempLast, tempFileId: tempId });

      if (response.type === 'GET_DUPLICATE_TEMP_AUTHS_FAILURE') {
        this.setState({duplicateAuths: {...this.state.duplicateAuths, auths: [], lastName: this.state.selectedAuth.tempFile.lastName, helperText: undefined}});        
        this.props.showToast(response.messages, { severity: TOAST_MESSAGE_SEVERITY_ERROR } );
        return;
      }

      if(response.response.length > 0) this.setState({duplicateAuths: {...this.state.duplicateAuths, auths: response.response.filter((auth) => auth.lastName === this.state.selectedAuth.tempFile.lastName), helperText: undefined, displayAuthsTable: true}});
      else this.setState({duplicateAuths: {...this.state.duplicateAuths, auths: [], lastName: this.state.selectedAuth.tempFile.lastName, helperText: 'No similar auths found'}});
    }
  }

  handleFormFieldChange = (name) => (event) => {
    let updateValue = '';

    if (event != null && !event.target) {
      updateValue = event;
    } else if (event && event.target) {
      updateValue = event.target.value;
    }

    let updateSelectedAuth = {
      ...this.state.selectedAuth.tempFile,
      [name]: updateValue,
    };

    let updateAuth = {
      ...this.state.selectedAuth,
      tempFile: updateSelectedAuth,
    };

    // check if country was updated to be blank. if so, clear state as well
    if (name === 'departureCountryId' && updateValue === '') {
      updateSelectedAuth['departureCountryId'] = '';
    }

    if (name === 'destinationCountryId' && updateValue === '') {
      updateSelectedAuth['destinationCountryId'] = '';
    }

    // the estimated end date field is hidden for other move types, so clear it
    if (name === 'moveTypeId' && !isEstimatedEndDateMoveType(updateValue)) {
      updateSelectedAuth['estimatedEndDate'] = '';
    }

    // if (name === 'ReloPolicy')
    //   updateSelectedAuth.ClientCustomFields = this.prepareLinkedTextFields(
    //     this.props.clientFields,
    //     updateSelectedAuth.ReloPolicy,
    //   );

   
    return new Promise((resolve) => {
      this.setState({
        selectedAuth: updateAuth,
        dirty: true,
      }, resolve);
    });
  };

  handleCustomFieldChange = (name) => (event) => {
    let updateValue = '';

    if (event != null && !event.target) {
      updateValue = event;
    } else if (event && event.target) {
      updateValue = event.target.value;
    }

    const customField = this.state.selectedAuth.customFields.find((field) => field.customFieldCommonId === name);
    if (customField && customField.fieldTypeId === '725cc7d4-507f-4305-ad68-4d412a73ee70') {
      if (updateValue === true || updateValue === 'true') {
        updateValue = "true";
      } else if (updateValue === false || updateValue === 'false') {
        updateValue = "false";
      }
    }
    
    let updateSelectedAuth = this.state.selectedAuth.customFields.map((field) => {
      if (field.customFieldCommonId === name) {
        return {
          ...field,
          fieldValue: updateValue,
        }
      }
      else return field;
    });

    let updateAuth = {
      ...this.state.selectedAuth,
      customFields: updateSelectedAuth,
    };

   
    return new Promise((resolve) => {
      this.setState({
        selectedAuth: updateAuth,
        dirty: true,
      }, resolve);
    });
  };

  handleAddPTCodeHistory = () => {
    const ptCodeHistories = Array.isArray(this.state.selectedAuth.tempPTCodeHistories)
      ? [...this.state.selectedAuth.tempPTCodeHistories]
      : [];

    ptCodeHistories.push({
      tempPTCodeHistoryId: 0,
      tempFileId: this.state.selectedAuth?.tempFile?.tempFileId || 0,
      clientRecordId: this.state.selectedAuth?.tempFile?.clientRecordId || 0,
      isNonStandard: false,
      projectCode: '',
      taskCode: '',
      percentage: '',
      effectiveStartDate: '',
      effectiveEndDate: '',
      notes: '',
    });

    this.setState({
      selectedAuth: {
        ...this.state.selectedAuth,
        tempPTCodeHistories: ptCodeHistories,
      },
      dirty: true,
    });
  };

  handlePTCodeHistoryChange = (index, name) => (event) => {
    let updateValue = '';

    if (event != null && !event.target) {
      updateValue = event;
    } else if (event && event.target) {
      updateValue = event.target.value;
    }

    const currentHistories = Array.isArray(this.state.selectedAuth.tempPTCodeHistories)
      ? this.state.selectedAuth.tempPTCodeHistories
      : [];

    const updatedHistories = currentHistories.map((ptCode, ptCodeIndex) => {
      if (ptCodeIndex === index) {
        return {
          ...this.normalizePTCodeHistory(ptCode),
          [name]: updateValue,
        };
      }

      return this.normalizePTCodeHistory(ptCode);
    });

    this.setState({
      selectedAuth: {
        ...this.state.selectedAuth,
        tempPTCodeHistories: updatedHistories,
      },
      dirty: true,
    });
  };

  handleDeletePTCodeHistory = async (index) => {
    const currentHistories = Array.isArray(this.state.selectedAuth.tempPTCodeHistories)
      ? [...this.state.selectedAuth.tempPTCodeHistories]
      : [];

    const ptCodeToDelete = currentHistories[index];
    if (!ptCodeToDelete) {
      return;
    }

    const tempFileId = Number(ptCodeToDelete.tempFileId || this.state.selectedAuth?.tempFile?.tempFileId || 0);
    const tempPTCodeHistoryId = Number(ptCodeToDelete.tempPTCodeHistoryId || 0);

    // If it does not exist in the API yet, remove only from local state.
    if (!tempPTCodeHistoryId) {
      const updatedHistories = currentHistories.filter((_, historyIndex) => historyIndex !== index);
      this.setState({
        selectedAuth: {
          ...this.state.selectedAuth,
          tempPTCodeHistories: updatedHistories,
        },
        dirty: true,
      });
      return;
    }

    const response = await this.props.deleteTempPendingAuthPTCodeHistory(tempFileId, tempPTCodeHistoryId);

    if (response && response.type === 'DELETE_PENDING_AUTH_PT_CODE_SUCCESS') {
      const ptCodesFromApi = Array.isArray(response.response)
        ? response.response.map((ptCode) => this.normalizePTCodeHistory(ptCode))
        : currentHistories.filter((_, historyIndex) => historyIndex !== index);

      this.setState({
        selectedAuth: {
          ...this.state.selectedAuth,
          tempPTCodeHistories: ptCodesFromApi,
        },
        dirty: true,
      });
      this.props.showToast('PT Code deleted.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
    } else if (response && response.hasErrors) {
      this.props.showToast(response.messages, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      this.props.showToast('Error deleting PT Code. Please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  };

  // handleCustomFieldChange = (updatedCF) => {
  //   let updateFields = [].concat(this.state.selectedAuth.customFields);

  //   updateFields = updateFields.map((item) => {
  //     if (item.customFieldCommonId === updatedCF.customFieldCommonId) {
  //       item.fieldValue = updatedCF.fieldValue;
  //     }

  //     return item;
  //   });

  //   this.setState({
  //     selectedAuth: {
  //       tempFile: this.state.selectedAuth.tempFile,
  //       customFields: updateFields,
  //       attachments: this.state.selectedAuth.attachments
  //     },
  //     dirty: true,
  //   });
  // };

  handleCheckboxChange = (name) => (event) => {

  let updateValue = event.target.checked ? true : false;

  let updateSelectedAuth = {
    ...this.state.selectedAuth.tempFile,
    [name]: updateValue,
  };

  let updateAuth = {
    ...this.state.selectedAuth,
    tempFile: updateSelectedAuth,
  };

  return new Promise((resolve) => {
    this.setState({
      selectedAuth: updateAuth,
      dirty: true,
    }, resolve);
  });
};

  handleContactChange = (contactDetails) => {
    let updateSelectedAuth = Object.assign({}, this.state.selectedAuth.tempFile);

    if (contactDetails.phoneDetails) {
      // clear existing values and replace with contactDetails
      phoneTypeMap.forEach((item) => {
        let foundDetail = contactDetails.phoneDetails.find(
          (detail) => detail.type === item.type,
        );

        if (foundDetail) {
          updateSelectedAuth[item.field] = foundDetail.number;
        } else {
          updateSelectedAuth[item.field] = '';
        }
      });
    }

    if (contactDetails.emailDetails) {
      // clear existing values and replace with contactDetails
      emailTypeMap.forEach((item) => {
        let foundDetail = contactDetails.emailDetails.find(
          (detail) => detail.type === item.type,
        );
        if (foundDetail) {
          updateSelectedAuth[item.field] = foundDetail.address;
        } else {
          updateSelectedAuth[item.field] = '';
        }
      });
    }

    this.setState({
      selectedAuth: { ...this.state.selectedAuth, tempFile: updateSelectedAuth },
      dirty: true,
    });
  };

  // require end date if the MoveType is specified, and not permanent
  // isEndDateRequired = (value) => {
  //   const { MoveType } = this.state.selectedAuth;
  //   if (!value && isProposedEndDateRequired(MoveType)) {
  //     return 'Required if Non-Permanent Move Type';
  //   }
  //   return null;
  // };

  // startDateMustBeBeforeEndDate = (value) => {
  //   let { ProposedEndDate } = this.state.selectedAuth;

  //   if (value && ProposedEndDate) {
  //     try {
  //       const startDate = new Date(value).getTime();
  //       const endDate = new Date(ProposedEndDate).getTime();
  //       return startDate < endDate ? null : 'Must be before Proposed End Date';
  //     } catch (e) {
  //       return null;
  //     }
  //   }
  //   return null;
  // };

  endDateMustBeAfterStartDate = (value) => {
    const effectiveDate = this.state.selectedAuth?.tempFile?.effectiveDate;

    if (value && effectiveDate) {
      try {
        const endDate = new Date(value).getTime();
        const startDate = new Date(effectiveDate).getTime();
        return endDate > startDate ? null : 'Must be after Effective Date';
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  // isSelfServicePolicyValid = (selfServicePolicies, reloPolicy, selectedPolicyId) => {
  //   const selectedPolicy = selfServicePolicies.find((pol) => pol.clientPolicyId === selectedPolicyId);
  //   if (!selectedPolicy) {
  //     return undefined;
  //   }
  //   let isSelectedPolicyValid = false;
  //   if (selectedPolicy.moveTrackPolicies.length) {
  //     isSelectedPolicyValid = selectedPolicy.moveTrackPolicies.some((mtPol) => mtPol.name === reloPolicy);
  //   }
  //   return isSelectedPolicyValid ? undefined : 'No longer valid';
  // };

  // Require a province/state when the selected country offers one.
  hasProvinceOptionsForCountry = (countryId) => {
    const provinceEnums = Array.isArray(this.props.provinceEnums)
      ? this.props.provinceEnums
      : [];

    return provinceEnums.some((province) => province.countryId === countryId);
  };

  isProvinceRequired = (countryId) => {
    return this.hasProvinceOptionsForCountry(countryId);
  };

  isCustomFieldRequired = (field) => {
    const fieldDefinitions = this.props.clientInfo?.clientCustomFields || [];
    const fieldDefinition = fieldDefinitions.find(
      (definition) => definition.customFieldCommonId === field.customFieldCommonId,
    );
    const dependencies = fieldDefinition?.customFieldDependencies || [];

    if (dependencies.length === 0) {
      return !!field.isRequiredField;
    }

    const tempFile = this.state.selectedAuth?.tempFile || {};
    const customFields = this.state.selectedAuth?.customFields || [];
    const divisions = this.props.clientInfo?.clientDivisions || [];
    const policies = this.props.clientInfo?.clientRelocationPolicies || [];
    const dependenciesByField = dependencies.reduce((groups, dependency) => {
      const key = dependency.fieldDependentOnId || '__unknown_dependency__';
      groups[key] = [...(groups[key] || []), dependency];
      return groups;
    }, {});

    let isConditionallyRequired = false;
    const isDisplayed = Object.keys(dependenciesByField).every((dependencyKey) => {
      return dependenciesByField[dependencyKey].some((dependency) => {
        let dependentField = dependency.fieldDependentOnId;
        let expectedValues = [dependency.fieldDependentOnValueId];

        if (dependentField === 'Division') {
          dependentField = 'divisionId';
          expectedValues = `${dependency.fieldDependentOnValueId || ''}`
            .split(';')
            .map((divisionName) => divisions.find((division) => division.divisionName === divisionName)?.clientDivisionId)
            .filter(Boolean);
        } else if (dependentField === 'Relocation Policy') {
          dependentField = 'policyId';
          expectedValues = `${dependency.fieldDependentOnValueId || ''}`
            .split(';')
            .map((policyName) => policies.find((policy) => policy?.policy?.policyDescription === policyName)?.policy?.relocationPolicyId)
            .filter(Boolean);
        } else {
          dependentField = fieldDefinitions.find(
            (definition) => definition.fieldLabel === dependentField,
          )?.customFieldCommonId;
        }

        const value = dependentField === 'policyId' || dependentField === 'divisionId'
          ? tempFile[dependentField]
          : customFields.find((customField) => customField.customFieldCommonId === dependentField)?.fieldValue;
        const matches = expectedValues.some((expectedValue) => {
          switch (dependency.fieldDependentOnOperationId) {
          case '98ba1156-a956-45db-9d68-10f2e345b7f9': return value === expectedValue;
          case '6b8ec837-01c9-4773-ad3c-0e6c41263678': return value !== expectedValue;
          case '9b12aa29-1027-40a0-9843-8d861d688249': return value != null && value !== '';
          case 'd73311f5-41bc-4e0e-8048-92b0722c5bae': return value == null || value === '';
          case 'e78add1f-2d1c-4241-b15b-2a7dcf12657d': return value > expectedValue;
          case '01a99433-8b24-4ac8-a004-7e9c8e17c3a0': return value < expectedValue;
          default: return false;
          }
        });

        if (matches && dependency.isMakeRequired) {
          isConditionallyRequired = true;
        }
        return matches;
      });
    });

    return isDisplayed && (!!field.isRequiredField || isConditionallyRequired);
  };

  isCustomFieldRequired = (field) => {
    const fieldDefinitions = this.props.clientInfo?.clientCustomFields || [];
    const fieldDefinition = fieldDefinitions.find(
      (definition) => definition.customFieldCommonId === field.customFieldCommonId,
    );
    const dependencies = fieldDefinition?.customFieldDependencies || [];

    if (dependencies.length === 0) {
      return !!field.isRequiredField;
    }

    const tempFile = this.state.selectedAuth?.tempFile || {};
    const customFields = this.state.selectedAuth?.customFields || [];
    const divisions = this.props.clientInfo?.clientDivisions || [];
    const policies = this.props.clientInfo?.clientRelocationPolicies || [];
    const dependenciesByField = dependencies.reduce((groups, dependency) => {
      const key = dependency.fieldDependentOnId || '__unknown_dependency__';
      groups[key] = [...(groups[key] || []), dependency];
      return groups;
    }, {});

    let isConditionallyRequired = false;
    const isDisplayed = Object.keys(dependenciesByField).every((dependencyKey) => {
      return dependenciesByField[dependencyKey].some((dependency) => {
        let dependentField = dependency.fieldDependentOnId;
        let expectedValues = [dependency.fieldDependentOnValueId];

        if (dependentField === 'Division') {
          dependentField = 'divisionId';
          expectedValues = `${dependency.fieldDependentOnValueId || ''}`
            .split(';')
            .map((divisionName) => divisions.find((division) => division.divisionName === divisionName)?.clientDivisionId)
            .filter(Boolean);
        } else if (dependentField === 'Relocation Policy') {
          dependentField = 'policyId';
          expectedValues = `${dependency.fieldDependentOnValueId || ''}`
            .split(';')
            .map((policyName) => policies.find((policy) => policy?.policy?.policyDescription === policyName)?.policy?.relocationPolicyId)
            .filter(Boolean);
        } else {
          dependentField = fieldDefinitions.find(
            (definition) => definition.fieldLabel === dependentField,
          )?.customFieldCommonId;
        }

        const value = dependentField === 'policyId' || dependentField === 'divisionId'
          ? tempFile[dependentField]
          : customFields.find((customField) => customField.customFieldCommonId === dependentField)?.fieldValue;
        const matches = expectedValues.some((expectedValue) => {
          switch (dependency.fieldDependentOnOperationId) {
          case '98ba1156-a956-45db-9d68-10f2e345b7f9': return value === expectedValue;
          case '6b8ec837-01c9-4773-ad3c-0e6c41263678': return value !== expectedValue;
          case '9b12aa29-1027-40a0-9843-8d861d688249': return value != null && value !== '';
          case 'd73311f5-41bc-4e0e-8048-92b0722c5bae': return value == null || value === '';
          case 'e78add1f-2d1c-4241-b15b-2a7dcf12657d': return value > expectedValue;
          case '01a99433-8b24-4ac8-a004-7e9c8e17c3a0': return value < expectedValue;
          default: return false;
          }
        });

        if (matches && dependency.isMakeRequired) {
          isConditionallyRequired = true;
        }
        return matches;
      });
    });

    return isDisplayed && (!!field.isRequiredField || isConditionallyRequired);
  };

  getFormErrors() {
    let errors = [];
    const allowEmptyDestination = userHasPermission('authorization:allowEmptyDestination', this.props.clientDivisions);

    //check to see if errors came back from the API. If so, handle only those
    if(apiFormErrors.length > 0){
        errors = apiFormErrors; //assign apiFormErrors to errors since they are the same formaat
        apiFormErrors = []; //set back to empty array so it won't trigger again
        return errors;  //return just the errors from the API
    }

    let fieldValidations = [
      {
        name: 'firstName',
        validators: [requiredField],
        friendlyName: 'First Name',
      },
      {
        name: 'lastName',
        validators: [requiredField],
        friendlyName: 'Last Name',
      },
      {
        name: 'departureAddressLine1',
        validators: (isKlaTaxClient() === true || isSamsungClient() === true) ? [] : [requiredField], //isKlaTaxClient() logic added via AB#869; And the Samsung part added via AB#1361
        friendlyName: 'Departure Address Line 1',
      },
      {
        name: 'departureCity',
        validators: (isKlaTaxClient() === true) ? [] : [requiredField], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Departure City',
      },
      {
        name: 'departureCountryId',
        validators: (isKlaTaxClient() === true) ? [] : [requiredField], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Departure Country',
      },
      {
        name: 'workEmail',
        validators: (isKlaTaxClient() === true) ? [] : [validEmail], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Work Email Address',
      },
      {
        name: 'spouseEmail',
        validators: (isKlaTaxClient() === true) ? [] : [validEmail], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Spouse Email Address',
      },
      {
        name: 'personalEmail',
        validators: (isKlaTaxClient() === true) ? [] : [validEmail], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Personal Email Address',
      },
      {
        name: 'homePhone',
        validators: (isKlaTaxClient() === true) ? [] : [validPhoneNumber], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Home Phone',
      },
      {
        name: 'officePhone',
        validators: (isKlaTaxClient() === true) ? [] : [validPhoneNumber], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Office Phone',
      },
      {
        name: 'mobilePhone',
        validators: (isKlaTaxClient() === true) ? [] : [validPhoneNumber], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Mobile Phone',
      },
      {
        name: 'employeeTypeId',
        validators: [requiredField],
        friendlyName: 'Employee Type',
      },
      {
        name: 'policyId',
        validators: [requiredField],
        friendlyName: 'Program Type',
      },
      {
        name: 'departureProvinceId',
        validators: [
          () => {
            const departureCountryId = this.state.selectedAuth?.tempFile?.departureCountryId;
            const departureProvinceId = this.state.selectedAuth?.tempFile?.departureProvinceId;

            return this.isProvinceRequired(departureCountryId) &&
              departureCountryId !== '' &&
              (departureProvinceId === '' || departureProvinceId === null || departureProvinceId === undefined) &&
              isKlaTaxClient() !== true  //isKlaTaxClient() logic added via AB#869
              ? 'Required'
              : null;
          },
        ],
        friendlyName: 'Departure State',
      },
      {
        name: 'estimatedEndDate',
        validators: isEstimatedEndDateMoveType(this.state.selectedAuth?.tempFile?.moveTypeId)
          ? [validDate, this.endDateMustBeAfterStartDate]
          : [],
        friendlyName: 'Estimated End Date',
      },
      {
        name: 'effectiveDate',
        validators: (isAirBornClient() === true) ? [requiredField, validDate, this.startDateMustBeBeforeEndDate] : [validDate, this.startDateMustBeBeforeEndDate],
        friendlyName: 'Effective Date',
      },
      // {
      //   name: 'SelfServicePolicyId',
      //   validators: [
      //     (value) => this.isSelfServicePolicyValid(this.props.selfServicePolicies, this.state.selectedAuth.ReloPolicy, value),
      //   ],
      //   friendlyName: 'Self Service Policy',
      // },
      // {
      //   name: 'SelfServicePolicyBudget',
      //   validators: [
      //     (value) => {
      //       if (this.state.selectedAuth.SelfServicePolicyId) {
      //         return requiredField(value);
      //       }
      //       return undefined;
      //     },
      //   ],
      //   friendlyName: 'Self Service Policy Budget',
      // },
    ];
  
    //if client ID is 238 (MPC) or 242 (Speedway), don't require the moveType field
    if(getSelectedClientInformation().id !== '238' && getSelectedClientInformation().id !== '242') {
      fieldValidations.push({
        name: 'moveTypeId',
        validators: [requiredField],
        friendlyName: 'Move Type'
      })
    }
  
   
    if (!allowEmptyDestination){
      fieldValidations.push({
        name: 'destinationCountryId',
        validators: (isKlaTaxClient() === true) ? [] : [requiredField], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Destination Country',
      });

      fieldValidations.push({
        name: 'destinationCity',
        validators: (isKlaTaxClient() === true) ? [] : [requiredField], //isKlaTaxClient() logic added via AB#869
        friendlyName: 'Destination City',
      });

      fieldValidations.push({
        name: 'destinationProvinceId',
        validators: [
          () => {
            const destinationCountryId = this.state.selectedAuth?.tempFile?.destinationCountryId;
            const destinationProvinceId = this.state.selectedAuth?.tempFile?.destinationProvinceId;

            return (!allowEmptyDestination &&
              this.isProvinceRequired(destinationCountryId)) &&
              destinationCountryId !== '' &&
              (destinationProvinceId === '' || destinationProvinceId === null || destinationProvinceId === undefined) &&
              isKlaTaxClient() !== true  //isKlaTaxClient() logic added via AB#869
              ? 'Required'
              : null;
          },
        ],
        friendlyName: 'Destination State',
      });
    }

    const tempFile = this.state.selectedAuth?.tempFile || {};
    fieldValidations.forEach((fieldValidation) => {
      fieldValidation.validators.filter((validator) => typeof validator === 'function').forEach((validator) => {
        const error = validator(tempFile[fieldValidation.name]);
        if (error) {
          errors.push(`${fieldValidation.friendlyName}: ${error}`);
        }
      });
    });

    // validate custom fields and client custom fields
    if (this.state.selectedAuth.customFields) { 
      this.state.selectedAuth.customFields.forEach((field) => {
        
        if (!field.fieldValue && this.isCustomFieldRequired(field)) {
          errors.push(`${field.fieldLabel  }: Required`);
        }

        if (field.fieldTypeId === '1235ae4Cc-ba8f-4ba6-91c7-2af61524325a' && validDate(field.fieldValue)) {
          errors.push(`${field.fieldLabel  }: Invalid Date Format`);
        }

        if(field.fieldLabel === "Client Employee ID" && field.fieldValue && field.fieldValue.length > 25) errors.push(`${field.fieldLabel  }: Can't be longer than 25 characters`);
      });
    }

    if (this.props.clientFields) {
      this.props.clientFields.forEach((field) => {
        if (field.IsRequired) {
          errors.push(`${field.fieldLabel  }: Required`);
        }
      });
    }

    if (this.state.selectedAuth && this.state.selectedAuth.tempFile && (this.state.selectedAuth.tempFile.homePhone.length === 0 && this.state.selectedAuth.tempFile.workPhone.length === 0 && this.state.selectedAuth.tempFile.mobilePhone.length === 0)) {
      errors.push('Phone Number: At least one is required');
    }

    if (this.state.selectedAuth && this.state.selectedAuth.tempFile && (this.state.selectedAuth.tempFile.workEmail.length === 0 && this.state.selectedAuth.tempFile.spouseEmail.length === 0 && this.state.selectedAuth.tempFile.personalEmail.length === 0)) {
      errors.push('Email Address: At least one is required');
    }

    const ptCodeHistories = Array.isArray(this.state.selectedAuth.tempPTCodeHistories)
      ? this.state.selectedAuth.tempPTCodeHistories.map((ptCode) => this.normalizePTCodeHistory(ptCode))
      : [];

    ptCodeHistories.forEach((ptCode, index) => {
      if (this.isPTCodeHistoryEmpty(ptCode)) {
        return;
      }

      if (!ptCode.projectCode || `${ptCode.projectCode}`.trim() === '') {
        errors.push(`PT Code Row ${index + 1}: Project Code is required`);
      }

      if (!ptCode.taskCode || `${ptCode.taskCode}`.trim() === '') {
        errors.push(`PT Code Row ${index + 1}: Task Code is required`);
      }

      if (!ptCode.effectiveStartDate || `${ptCode.effectiveStartDate}`.trim() === '') {
        errors.push(`PT Code Row ${index + 1}: Effective Start Date is required`);
      }

      if (ptCode.percentage !== '' && ptCode.percentage !== null && ptCode.percentage !== undefined) {
        const parsedPercentage = Number(ptCode.percentage);
        if (Number.isNaN(parsedPercentage) || parsedPercentage < 0 || parsedPercentage > 100) {
          errors.push(`PT Code Row ${index + 1}: Percentage must be a number between 0 and 100`);
        }
      }

      if (ptCode.effectiveStartDate && ptCode.effectiveEndDate) {
        const startDate = moment(ptCode.effectiveStartDate);
        const endDate = moment(ptCode.effectiveEndDate);
        if (startDate.isValid() && endDate.isValid() && endDate.isBefore(startDate)) {
          errors.push(`PT Code Row ${index + 1}: Effective End Date must be on or after Effective Start Date`);
        }
      }
    });

    return errors;
  }

  // getLinkedTextFieldOption = (field) => {
  //   return (
  //     field.fieldTypeId === '5abfc239-5144-4155-91c2-68a71755f995' && field.fieldListValues.find((v) => v.includes('%'))
  //   );
  // };

  // getLinkedTextFieldOptionForKlaTaxAssignment = (field) => {
  //   return (
  //     field.fieldTypeId === '5abfc239-5144-4155-91c2-68a71755f995' && field.fieldListValues.find((v) => v.includes('%ChargeNum3%'))
  //   );
  // };

  // getLinkedTextFieldOptionForKlaTaxOther = (field) => {
  //   return (
  //     field.fieldTypeId === '5abfc239-5144-4155-91c2-68a71755f995' && field.fieldListValues.find((v) => (v.includes('%') && !v.includes('%ChargeNum3%')))
  //   );
  // };

  // getLinkedTextField = (listField, fields) => {
  //   if (!listField || listField.fieldTypeId !== '5abfc239-5144-4155-91c2-68a71755f995') return null;
  //   let linkedTextFieldOption = this.getLinkedTextFieldOption(listField);
  //   if (!linkedTextFieldOption) return null;
  //   return fields.find(
  //     (f) => f.fieldLabel === linkedTextFieldOption.replace(/%/g, ''),
  //   );
  // };

  // getLinkedTextFieldForKlaTaxAssignment = (listField, fields) => {
  //   if (!listField || listField.TextFormat !== 'List') return null;
  //   let linkedTextFieldOption = this.getLinkedTextFieldOptionForKlaTaxAssignment(listField);
  //   if (!linkedTextFieldOption) return null;
  //   return fields.find(
  //     (f) => f.FieldName === linkedTextFieldOption.replace(/%/g, ''),
  //   );
  // };

  // getLinkedTextFieldForKlaTaxOther = (listField, fields) => {
  //   if (!listField || listField.TextFormat !== 'List') return null;
  //   let linkedTextFieldOption = this.getLinkedTextFieldOptionForKlaTaxOther(listField);
  //   if (!linkedTextFieldOption) return null;
  //   return fields.find(
  //     (f) => f.FieldName === linkedTextFieldOption.replace(/%/g, ''),
  //   );
  // };

  // prepareLinkedTextFields = (fields, reloPolicy) => {

  //   const reloPolicyNameForCompare = !reloPolicy ? '' : reloPolicy.replace(/\s/g, '').replace(/[^a-z0-9]+/gi, '').toUpperCase();
  //   //reset fields not associated to current ReloPolicy
  //   fields.filter((f) => {
  //     if (!reloPolicy || reloPolicy.trim() === '') return false;

  //     return f.UserGroup === 'ReloPolicy' &&
  //       f.FieldName.toUpperCase() !== reloPolicyNameForCompare;
  //   },
  //   ).forEach((f) => {
  //     f.FieldValue = null;
  //   });

  //   const reloPolicyField = fields.find((f) => { 
  //     return f.UserGroup === 'ReloPolicy' && (!!reloPolicy && f.FieldName.toUpperCase() === reloPolicyNameForCompare);
  //   });

  //   // remove fields not linked to current ReloPolicy
  //   fields = fields.filter((f) => 
  //     f.UserGroup !== 'ReloPolicy' ||
  //     (reloPolicyField ? f === reloPolicyField : f.FieldName === 'NoPolicy'),
  //   );

  //   fields.forEach((field) => {
  //     if(isBattelleEnergyAllianceClient() === true) {
  //       // linked custom Charge Number "Assignment" field, for the "Battelle Energy Alliance" Client ONLY (via AB#869)
  //       const linkedTextFieldForAssignment = this.getLinkedTextFieldForKlaTaxAssignment(field, fields);
  //       if (linkedTextFieldForAssignment) {
  //         if (field.FieldValue !== this.getLinkedTextFieldOptionForKlaTaxAssignment(field)) {
  //           linkedTextFieldForAssignment.disabled = true;
  //           linkedTextFieldForAssignment.FieldValue = null;
  //           linkedTextFieldForAssignment.FieldRequired = false;
  //         } else {
  //           linkedTextFieldForAssignment.FieldRequired = true;
  //           linkedTextFieldForAssignment.disabled = false;
  //         }
  //       }
  //       // linked custom Charge Number "Other" field, for the "Battelle Energy Alliance" Client ONLY (via AB#869)
  //       const linkedTextFieldForOther = this.getLinkedTextFieldForKlaTaxOther(field, fields);
  //       if (linkedTextFieldForOther) {
  //         if (field.FieldValue !== this.getLinkedTextFieldOptionForKlaTaxOther(field)) {
  //           linkedTextFieldForOther.disabled = true;
  //           linkedTextFieldForOther.FieldValue = null;
  //           linkedTextFieldForOther.FieldRequired = false;
  //         } else {
  //           linkedTextFieldForOther.FieldRequired = true;
  //           linkedTextFieldForOther.disabled = false;
  //         }
  //       }
  //     } else {
  //       // linked "Other" fields
  //       const linkedTextField = this.getLinkedTextField(field, fields);
  //       if (linkedTextField) {
  //         if (field.FieldValue !== this.getLinkedTextFieldOption(field)) {
  //           linkedTextField.disabled = true;
  //           linkedTextField.FieldValue = null;
  //           linkedTextField.FieldRequired = false;
  //         } else {
  //           linkedTextField.FieldRequired = true;
  //           linkedTextField.disabled = false;
  //         }
  //       }
  //     }
  //   });

  //   //Added via AB#610 - For Handling H&P's (Helmerich and Payne) custom dropdown requirements and behavior.
  //   let areaIncentiveIndex = fields.findIndex(x => x.FieldName === 'AreaIncentive');
  //   let removeByDateIndex = fields.findIndex(x => x.FieldName === 'RemoveByDate');
  //   if(areaIncentiveIndex !== -1 && removeByDateIndex !== -1) {
  //     //ClientCustomField for 'AreaIncentive' was found; Handle the custom logic for the 'RemoveByDate' field, based upon the value of the 'AreaIncentive' field.
  //     if(fields[areaIncentiveIndex] && fields[areaIncentiveIndex].FieldValue === 'Yes') {
  //       fields[removeByDateIndex].disabled = false;
  //       fields[removeByDateIndex].FieldRequired = true;
  //       //fields[removeByDateIndex].FieldValue = null;
  //     } else {
  //       fields[removeByDateIndex].disabled = true;
  //       fields[removeByDateIndex].FieldRequired = false;
  //       fields[removeByDateIndex].FieldValue = null;
  //     }
  //   }

  //   return fields;
  // };

  // handleClientCustomFieldChange = (field) => (event) => {
  //   let allValeroWorkLocationCities = [].concat(this.state.allValeroWorkLocationCities);
  //   let allValeroWorkLocationCodes = [].concat(this.state.allValeroWorkLocationCodes);
  //   let updateFields = [].concat(this.state.selectedAuth.ClientCustomFields);
  //   let filteredCodes = [];
  //   // some controls send value directly, not wrapped in event
  //   let newValue = get(event, 'target.value', event);

  //   updateFields = updateFields.map((item) => {
  //     let foundUserField = field.UserFieldsId
  //       ? item.UserFieldsId === field.UserFieldsId
  //       : false;
  //     let foundPageField = field.PageFieldId
  //       ? item.PageFieldId === field.PageFieldId
  //       : false;

  //     if (foundUserField || foundPageField) {
  //       item.FieldValue = newValue;
  //     }
      
  //     //Added via AB#1360 - For handling Valero's custom dropdown requirements and behavior, if ValeroWorkLocation is selected, apply filtering to city and code as well. 
  //     // DIDN'T affect previous filtering. If city only is selected, code is still filtered as expected.
  //     // Changes applied 3/21/2025 by Vanessa Osterberg
  //     if(item && field && item.FieldName && field.FieldName && item.FieldName === 'ValeroWorkLocationCity' && field.FieldName === 'ValeroWorkLocation') {
  //       if(event === undefined || event === null) {
  //         item.FieldList = [].concat(allValeroWorkLocationCities);
  //         item.FieldValue = null;
  //       } else {
  //         let city = field.FieldList.find(fieldListValue => fieldListValue.toString()?.startsWith(event?.toString() + "|")).split("|")[1].replaceAll(" ", "");
  //         item.FieldList = allValeroWorkLocationCities.filter(fieldListValue => fieldListValue?.toString()?.replaceAll(" ", "").startsWith(city));
  //         if(item.FieldList.length > 1)
  //         {
  //           item.FieldList = [].concat(item.FieldList[0]);
  //           filteredCodes = allValeroWorkLocationCodes.filter(fieldListValue => fieldListValue?.toString()?.replaceAll(" ", "").startsWith(city.toString() + "|"));
  //         }
  //         else {
  //           filteredCodes = allValeroWorkLocationCodes.filter(fieldListValue => fieldListValue?.toString()?.replaceAll(" ", "").startsWith(city?.toString() + "|"));
  //         }
  //       }
  //     }

  //     if(item && item.FieldName && item.FieldName === 'ValeroWorkLocationCode')
  //     {
  //       item.FieldList = [].concat(filteredCodes);
  //     }

  //     //Added via AB#513 - For handling Valero's custom dropdown requirements and behavior.
  //     if(item && field && item.FieldName && field.FieldName && item.FieldName === 'ValeroWorkLocationCode' && field.FieldName === 'ValeroWorkLocationCity') {
  //       if(event === undefined || event === null) {
  //         item.FieldList = [].concat(allValeroWorkLocationCodes);
  //         item.FieldValue = null;
  //       } else {
  //         item.FieldList = allValeroWorkLocationCodes.filter(fieldListValue => fieldListValue?.toString()?.startsWith(event?.toString() + "|"));
  //       }
  //     }
      
  //     return item;
  //   });

  //   this.prepareLinkedTextFields(
  //     updateFields,
  //     this.state.selectedAuth.ReloPolicy,
  //   );

  //   this.setState({
  //     selectedAuth: {
  //       ...this.state.selectedAuth,
  //       ClientCustomFields: updateFields,
  //     },
  //     dirty: true,
  //   });
  // };

  

  userIsApprover() {
    const clientInfo = getSelectedClientInformation();
    const clientId = clientInfo.id;
     
    const permissions = getUserPermissionsList();
    const approverPermission = permissions.find((p) => p.includes(`user:${clientId}:approver`));

    if (!approverPermission)
      return false;
    
    let permSplit = approverPermission.split(':');
    if (permSplit.length === 3)
      return true;
    
    if (permSplit.length !== 5)
      return false;
    
    const userFieldName = permSplit[3];
    const permUserFieldValue = permSplit[4];

    const userFieldValue = this.getUserField(userFieldName);

    return permUserFieldValue === userFieldValue;
  }

  clientRequiresApproval() {
    const { clientInfo } = this.props;
    return  userHasPermission(
      'authorization:requiresApproval',
      clientInfo.clientDivisions,
    );
  }

  authWasSubmittedForApproval() {
    return this.state.authSubmitted !== null;
  }

  sumbitApproveButton(formHasErrors, forceDisabled = false) {
    
    const {
      isSubmitting,
    } = this.state;

    let onClickHandler = this.handleFormSubmit;
    let buttonCaption = 'Submit';
    let buttonDisabled = forceDisabled;

    const authWasSubmittedForApproval = this.authWasSubmittedForApproval();

    if (this.clientRequiresApproval()) {
      if (!this.userIsApprover()) {
        if (!authWasSubmittedForApproval) {
          onClickHandler = this.handleSubmitForApproval;
          buttonCaption = 'Submit For Approval';
        }
        else {
          onClickHandler = null;
          buttonCaption = 'Submitted for Approval';
          buttonDisabled = true;
        }
      }
      else {
        if (authWasSubmittedForApproval){
          buttonCaption = 'Approve';
        }
      }
    }

    return (
      <SpinnerButton
        isLoading={isSubmitting}
        buttonComponent={
          <Button
            variant="contained"
            color="primary"
            disabled={buttonDisabled || (formHasErrors || isSubmitting)}
            onClick={onClickHandler}
          >
            {buttonCaption}
          </Button>
        }
      />
    );
  }

  render() {
    const {
      classes,
      clientFieldValues,
      clientFields,
      authCustomFields,
      reloPolicies,
      selfServicePolicies,
      busCodes,
      drawerOpen,
    } = this.props;
    const {
      tabIndex,
      selectedAuth,
      isLoadingAuth,
      dirty,
      authSubmitted,
      isEdit,
      isSubmitting,

    } = this.state;

    const formErrors = this.getFormErrors();
    const formHasErrors = formErrors.length > 0;

    const employeeFormData = {
      selectedAuth,
      clientFieldValues,
      clientFields,
      authCustomFields,
      reloPolicies,
      selfServicePolicies,
      busCodes,
    };

    // const divisionBusCode = this.getDivisionBusCode();
    // let isSaveDisabled =
    //   divisionBusCode && !isEdit ? divisionBusCode.BusCode === null : false;
    
    //TODO - Revert until cc integration is complete
    const isAuthorizer = true;
    const allowAddAuthorization = isClientSelected() && isAuthorizer;

    if (isLoadingAuth) {
      return (
        <div style={{ margin: '2rem' }}>
          <LogoSpinner />
        </div>
      );
    } else {
      return (
        <div>
          <NavigationPrompt when={dirty}>
            {({ onConfirm, onCancel }) => {
              return (
                <ConfirmModal
                  cancelText="Cancel"
                  confirmText="Confirm"
                  handleClose={onCancel}
                  handleConfirm={onConfirm}
                  titleText="Unsaved Changes"
                  bodyText="You have unsaved changes on this authorization. Would you like to leave this page?"
                />
              );
            }}
          </NavigationPrompt>
         
          {this.state.duplicateAuths.displayAuthsTable && (
            <DuplicateAuthsModal
              handleClose={this.handleDuplicateAuthsModalClose}
              auths={this.state.duplicateAuths.auths}
              handleSetSelectedAuthorization={this.handleSetSelectedAuthorization}
              handleSetSelectedTransferee={this.handleSetSelectedTransferee}
              handleSelectDuplicateAuthorization={this.handleSelectDuplicateAuthorization} 
              selectedAuthorizationID={this.state.duplicateAuths.selectedLinkedAuthorizationID} 
              linkedMtId={this.state.duplicateAuths.linkedMtId} 
              linkedTempId={this.state.duplicateAuths.linkedTempId} 
              clientId={getSelectedClientInformation().id}
              provinceEnums={this.props.provinceEnums}
              nextFileNumber={this.state.duplicateAuths.nextFileNumber}
            />
          )}

        {this.state.duplicateAuths.selectedAuthorizationID &&                 
            <AuthorizationModal            
              authorizationID = {this.state.duplicateAuths.selectedAuthorizationID}
              handleClose={this.handleDisplayAuthsModalClose}                          
            >
              </AuthorizationModal>
         }

        {this.state.duplicateAuths.selectedMtID &&                 
            <TransfereeModal            
              authorizationID={this.state.duplicateAuths.selectedMtID}
              handleClose={this.handleDisplayAuthsModalClose}                          
            />
         }


          <div className={classes.root}> 
            <AppBar position="static">
              <Tabs
                value={tabIndex}
                onChange={this.handleTabChange}
                variant="scrollable"
                scrollButtons="on"
              >
                <Tab
                  label={
                    <div style={{ display: 'inline' }}>
                      <div
                        style={{ verticalAlign: 'middle', display: 'inline' }}
                      >
                        Employee Information
                      </div>
                      {formHasErrors && (
                        <span>
                          <FontAwesomeIcon
                            icon="exclamation-triangle"
                            style={{
                              marginLeft: '0.5rem',
                              display: 'inline',
                              height: '15px',
                              verticalAlign: 'middle',
                            }}
                          />
                        </span>
                      )}
                    </div>
                  }
                />
                <Tab
                  disabled={!selectedAuth.tempFile.tempFileId}
                  label="Documents / Notes"
                />
                <Tab disabled={!selectedAuth.tempFile.tempFileId} label="Summary" />
              </Tabs>
            </AppBar>
            
            { (this.state.authSubmitted === true && !this.props.isModalRequest) &&   
              <div className={classes.cannotBeEdited}>
                This authorization has already been submitted and cannot be edited
                {userHasPermission('authorization:regeneratepdf', this.props.clientInfo.divisions) && (
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={this.state.isRegeneratingPdf}
                    onClick={this.handleRegeneratePdf}
                    style={{ marginLeft: '1rem' }}
                  >
                    {this.state.isRegeneratingPdf ? 'Regenerating...' : 'Regenerate Auth PDF'}
                  </Button>
                )}
              </div>
            }
            
            {tabIndex === 0 && (
              <TabContainer>
              <EmployeeForm
                  formData={employeeFormData}
                  allEnums={this.props.allEnums}
                  countryEnums={this.props.countryEnums}
                  provinceEnums={this.props.provinceEnums}
                  customFields={this.props.customFields}
                  isEdit={isEdit}
                  handleContactChange={this.handleContactChange}
                  handleFormChange={this.handleFormFieldChange}
                  handleOnBlur={this.handleOnBlur}
                  handleCheckboxChange={this.handleCheckboxChange}
                  handleCustomFieldChange={this.handleCustomFieldChange}
                  handleAddPTCodeHistory={this.handleAddPTCodeHistory}
                  handlePTCodeHistoryChange={this.handlePTCodeHistoryChange}
                  handleDeletePTCodeHistory={this.handleDeletePTCodeHistory}
                  handleClientCustomFieldChange={this.handleClientCustomFieldChange}
                  readonly={authSubmitted}
                  duplicateAuthHelperText={this.state.duplicateAuths.helperText}
                  hasConfidentialFileAccess={this.state.hasConfidentialFileAccess}
                />
              </TabContainer>
            )}
            {tabIndex === 1 && (
              <TabContainer>
                <NotesForm
                  formData={employeeFormData}
                  handleFormChange={this.handleFormFieldChange}
                  disabled={!selectedAuth.tempFile.tempFileId}
                  readonly={authSubmitted}
                />
              </TabContainer>
            )}
            {tabIndex === 2 && (
              <TabContainer>
                <SummaryForm
                  formData={{ errors: formErrors }}
                  isSubmitted={authSubmitted}
                  authWasSubmittedForApproval={this.authWasSubmittedForApproval()}
                  clientRequiresApproval={this.clientRequiresApproval()}
                  userIsApprover={this.userIsApprover()}
                />
              </TabContainer>
            )}

            {!authSubmitted && (
              <div style={{ padding: '1rem', display: 'flex', marginLeft: drawerOpen ? 0 : 100 }}>
                {this.state.duplicateAuths.auths !== undefined && 
                  Array.isArray(this.state.duplicateAuths.auths) &&
                  this.state.duplicateAuths.auths.length > 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.saveButton}
                    onClick={this.handleReopenDuplicateModal}
                    disabled={!this.state.duplicateAuths.auths?.length}
                >
                  Review Similar Authorizations
                </Button>
                )}
                {this.state.duplicateAuths.nextFileNumber &&
                  (this.state.duplicateAuths.linkedMtId || this.state.duplicateAuths.linkedTempId) && (
                    <div style={{ marginLeft: 12, alignSelf: 'center', fontSize: 12, color: '#666' }}>
                      Creating a '{this.state.duplicateAuths.nextFileNumber.slice(-1).toUpperCase()}'
                      {' '}file for{' '}
                      {this.state.duplicateAuths.linkedMtId
                        ? `authorization #${this.state.duplicateAuths.linkedMtId}`
                        : `temp file #${this.state.duplicateAuths.linkedTempId}`}
                    </div>
                  )}
                <SpinnerButton
                  isLoading={isSubmitting}
                  buttonComponent={
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={  isSubmitting}
                      className={classes.saveButton}
                      onClick={() => this.handleFormSave(false)}
                    >
                      Save
                    </Button>
                  }
                />

                <SpinnerButton
                  isLoading={isSubmitting}
                  buttonComponent={
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={  isSubmitting}
                      className={classes.saveButton}
                      onClick={() => this.handleFormSave(true)}
                    >
                      Save and Exit
                    </Button>
                  }
                />

                <div className={classes.navButtons}>
                  {/* {tabIndex > 0 && selectedAuth.AuthorizationID &&
                  <Button variant="contained" color="primary" onClick={this.prevPage} style={{ marginRight: '0.25rem' }}>Previous</Button>
                } */}
                  {tabIndex !== 2 && (
                    <SpinnerButton
                      isLoading={isSubmitting}
                      buttonComponent={
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                          onClick={this.nextPage}
                        >
                          Next
                        </Button>
                      }
                    />
                  )}
                  {tabIndex === 2 && this.sumbitApproveButton(formHasErrors, !allowAddAuthorization)}
                </div>
              </div>
            )}            
          </div>
        </div>
      );
    }
  }
}

AuthorizationEditCreate.propTypes = {
  classes: PropTypes.object.isRequired,
};

AuthorizationEditCreate = withStyles(styles)(AuthorizationEditCreate);

const mapStateToProps = (state) => {
  return {
    selectedAuth: state.authorizations.get('pendingAuthorization'),
    countries: state.authorizations.get('countries'),
    clientFieldValues: state.authorizations.get('clientFieldValues'),
    clientFields: state.authorizations.get('clientFields'),
    authCustomFields: state.authorizations.get('authCustomFields'),
    reloPolicies: state.authorizations.get('reloPolicies'),
    selfServicePolicies: state.policy.policies,
    busCodes: state.authorizations.get('busCodes'),
    pendingAuthorizations: state.authorizations.get('pendingAuthorizations'),
    userInformation: state.layout.get('userInformation'),
    clientDivisions: state.layout.get('clientDivisions'),
    userContact: state.layout.get('userContact'),
    drawerOpen: state.layout.get('drawerOpen'),
    baseMoveInfo: state.transferees.get('baseMoveInfo'),
    clientInfo: state.authorizations.get('clientInfo'),
    allEnums: state.authorizations.get('allEnums'),
    countryEnums: state.authorizations.get('countryEnums'),
    provinceEnums: state.authorizations.get('provinceEnums'),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getPendingAuthorization,
    getCountries,
    getStates,
    getAuthorizationCustomFields,
    getClientFieldListValues,
    getClientSpecificFields,
    getReloPolicies,
    getPolicies,
    getBusCodes,
    updateAuthorization,
    showToast,
    insertAuthorization,
    submitAuthorization,
    submitAuthorizationForApproval,
    getDuplicateAuths,
    regenerateAuthPdf,
    getTempAuthFiles,
    setPageTitle,
    setNumPendingTransferees,
    setBackButtonPath,
    setBaseMoveInfo,
    getEstimates,
    getHomesalePriceByRegion,
    getFlightPrice,
    getAutoShipmentCost,
    getPackLoadMovePrice,
    getTempLivingPriceByRegion,
    getTempPendingAuthById,
    getTempPendingAuthClientCustomFields,
    getClientInformation,
    getAllEnumerations,
    getAllCountries,
    getAllProvinces,
    updateTempPendingAuth,
    insertTempPendingAuth,
    deleteTempPendingAuthPTCodeHistory,
    getTempFileDuplicateAuths,
    submitTempFile
  })(AuthorizationEditCreate),
);